import script from "./rateApplication.vue?vue&type=script&setup=true&lang=js"
export * from "./rateApplication.vue?vue&type=script&setup=true&lang=js"

import "./rateApplication.vue?vue&type=style&index=0&id=7ad102ea&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ad102ea"]])

export default __exports__